module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/banco-itau-logo-83fbbce02e3e7144cc3a6ec4e0fb7a64.svg";